export const Back = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.59625 4.5L4.06417 8.20451C3.64528 8.64385 3.64528 9.35616 4.06417 9.7955L7.59625 13.5M4.37834 9.00001H14.25"
      stroke="#A1AEB7"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
